import React from 'react';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import { Grid } from 'semantic-ui-react';
import MoreVert from '@material-ui/icons/MoreVert';
import Server from '../../functions/server'
import $ from "jquery";
import Dialogbox from './dialogbox';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Loading from '../loading';
import { Link } from 'react-router-dom';
import Release from '../../functions/release';

class OrderStatus extends React.Component {

  state = { open: false, data: [] }

  viewBranch(type) {
    let context = this;
    context.setState({ load: true, message: 'Getting Values' })
    $.ajax({
      type: 'POST', data: { 'type': type },
      url: Server() + 'dashboard/orderstatusbranch.php',
      success: function(data) {
        try {
          data = JSON.parse(data);
          context.setState({ data: data, open: true, load: false })
        } catch (e) {
          context.setState({ load: false })
        }
      },
      error: function(e) {
        alert('Try again!!')
        context.setState({ load: false });
      }
    });
  }

  render() {
    let back_order, pending_order, waiting_order, approved_order;
    let back_order_total, pending_order_total, waiting_order_total, approved_order_total;
    let data = this.props.data.map((x) => {
      back_order = x.back_order;
      pending_order = x.pending_order;
      waiting_order = x.waiting_order;
      approved_order = x.approved_order;
      back_order_total = x.back_order_total;
      pending_order_total = x.pending_order_total;
      waiting_order_total = x.waiting_order_total;
      approved_order_total = x.approved_order_total;
    });
    back_order_total = Number(back_order_total);
    back_order_total = back_order_total.toFixed(2);
    pending_order_total = Number(pending_order_total);
    pending_order_total = pending_order_total.toFixed(2);
    waiting_order_total = Number(waiting_order_total);
    waiting_order_total = waiting_order_total.toFixed(2);
    approved_order_total = Number(approved_order_total);
    approved_order_total = approved_order_total.toFixed(2);
    let fontSize = 15;
    let i = 0;
    let overallTotal = 0;
    let overallItems = 0;
    let overallOrders = 0;
    return (
      <div>
        <Loading load={this.state.load} message={this.state.message} />
        <Grid>
          <Grid.Column mobile={16} tablet={16} computer={16}>
            <Card style={{backgroundColor: '#abb119'}}>
              <div style={{display: 'flex', padding: '2%'}}>
                <div style={{fontSize: 17, color: 'white'}}><b>Order Status</b></div>
              </div>
              <Grid>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Waiting<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{waiting_order}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{"₹"+waiting_order_total}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'Waiting')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Approved<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{approved_order}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{"₹"+approved_order_total}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'Approved')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Back Order<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{back_order}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{"₹"+back_order_total}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'Prior Order')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
                <Grid.Column mobile={16} tablet={16} computer={4}>
                  <Link to={"/"+Release()+"/place-order"}>
                    <CardContent>
                        <div style={{color: 'white'}}>Pending For Del<br/></div>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{pending_order}</b><br/>
                        <b style={{color: 'white', paddingTop: '4%', fontSize: fontSize}}>{"₹"+pending_order_total}</b>
                    </CardContent>
                  </Link>
                  <CardActions>
                    <Button size="small" onClick={this.viewBranch.bind(this, 'Pending For Delivery')} style={{color: 'white'}}>View Branch</Button>
                  </CardActions>
                </Grid.Column>
              </Grid>
            </Card>
          </Grid.Column>
        </Grid>
        { this.state.open ?
          (
            <div>
              <Dialog fullWidth={this.state.fullWidth}  maxWidth={this.state.maxWidth}
                open={this.state.open} onClose={ () => { this.setState({ open: false }) }} aria-labelledby="max-width-dialog-title">
                <DialogTitle style={{width: 500}}>{'Order Status Report'}</DialogTitle>
                <DialogContent>
                  <table id="table" width="100%">
                    <tr>
                      <th id="tableheader"><center>{'Sino'}</center></th>
                      <th id="tableheader"><center>{'Branch'}</center></th>
                      <th id="tableheader"><center>{'Stock`s'}</center></th>
                      <th id="tableheader"><center>{'Item`s'}</center></th>
                      <th id="tableheader"><center>{'Order`s'}</center></th>
                    </tr>
                    <tbody>
                      { this.state.data.map((x) => {
                          i++;
                          let tot;
                          let items, orders;
                          try {
                            tot = Number(x.total);
                          } catch (e) {
                            tot = 0;
                          }
                          try {
                            items = Number(x.items);
                          } catch (e) {
                            items  = 0;
                          }
                          try {
                            orders = Number(x.orders);
                          } catch (e) {
                            orders  = 0;
                          }
                          overallTotal = overallTotal + tot;
                          overallItems = overallItems + items;
                          overallOrders = overallOrders + orders;
                          return (
                            <tr>
                              <td><center>{i}</center></td>
                              <td><center>{x.branch_id+"->"+x.branch_name}</center></td>
                              <td style={{textAlign: 'right'}}>{tot}</td>
                              <td style={{textAlign: 'right'}}>{items}</td>
                              <td style={{textAlign: 'right'}}>{orders}</td>
                            </tr>
                          )
                        })
                      }
                      <tr>
                        <td colspan="2" style={{textAlign: 'right'}}><b>Total</b></td>
                        <td style={{textAlign: 'right'}}>{overallTotal}</td>
                        <td style={{textAlign: 'right'}}>{overallItems}</td>
                        <td style={{textAlign: 'right'}}>{overallOrders}</td>
                      </tr>
                    </tbody>
                  </table>
                </DialogContent>
                <DialogActions>
                  <Button onClick={ () => { this.setState({ open: false }) }} color="primary">Close</Button>
                </DialogActions>
              </Dialog>
            </div>
          ) :
          (
            <div></div>
          )
        }
      </div>
    );
  }
}

export default OrderStatus;
